import { Stack } from "@mui/material";

import { LoadingButton } from "../../components/LoadingButton";
import { type WorkerRequirement } from "../api/types";
import { DocumentsPageDocumentCards } from "./DocumentCards";

interface DocumentsPageWorkplaceSpecificDocumentsSectionProps {
  documents: WorkerRequirement[] | undefined;
  hasNextPage: boolean;
  isLoadingMore: boolean;
  onLoadMore: () => Promise<void>;
}

export function DocumentsPageWorkplaceSpecificDocumentsSection(
  props: DocumentsPageWorkplaceSpecificDocumentsSectionProps
) {
  const { documents, hasNextPage, isLoadingMore, onLoadMore } = props;

  return (
    <Stack spacing={4}>
      <DocumentsPageDocumentCards documents={documents} />
      {hasNextPage && (
        <LoadingButton variant="outlined" isLoading={isLoadingMore} onClick={onLoadMore}>
          Show more
        </LoadingButton>
      )}
    </Stack>
  );
}
